export const ORDER_STATUSES = Object.freeze({
  ARCHIVED: 'archived',
  OPEN: 'open',
  CLOSED: 'closed',
  CONFIRMED: 'confirmed',
  IN_TRANSIT: 'inTransit',
} as const);
